'use strict'

jQuery(($) => {
  $(window).on('load', function () {
    $('#sidr').removeClass('d-none')
  })

  $('.hamburger').sidr({
    name: 'sidr',
    side: 'right'
  })

  const Menu = {
    hamburger: null,
    linkMenuMobile: null,
    btnVoltarMenuMobile: null,
    tituloVoltar: null,

    init: function () {
      this.hamburger = $('.header__hamburguer')
      this.linkMenuMobile = $('.has-children > a')
      this.btnVoltarMenuMobile = $('.voltar-menu')
      this.tituloVoltar = $('.titulo')

        this.hamburger.on('touchstart', function () {
        Menu.ativaMobile()
      })
    },

    ativaMobile: function () {
      const wrap = $('.wrap')

      if (!this.hamburger.hasClass('is-active')) {
        $(this.hamburger).addClass('is-active')

        this.linkMenuMobile.on('click', function (e) {
          e.preventDefault()
          const selecionado = $(this)

          wrap.addClass('esconde')

          if (selecionado.next('ul').hasClass('is-hidden')) {
            selecionado
              .addClass('selecionado')
              .next('ul')
              .removeClass('is-hidden')
              .end()
              .parent('ul')
          }
        })

        this.btnVoltarMenuMobile.on('click', function (e) {
          e.preventDefault()

          Menu.resetaMobile(this)
        })

        this.tituloVoltar.on('click', function (e) {
          e.preventDefault()

          Menu.resetaMobile(this)
        })
      } else {
        $(this.hamburger).removeClass('is-active')
        Menu.resetaMobile(this)
      }
    },

    resetaMobile: function (ativo) {
      $(ativo)
        .parent('ul')
        .addClass('is-hidden')
        .parent('.has-children')
        .parent('ul')

      $('.link-menu-mobile').removeClass('selecionado')
      $('.wrap').removeClass('esconde')
      $('.nav-dropdown-mobile').addClass('is-hidden')
    }
  }

  Menu.init()
})
